import {
  tuneSubscribe,
  tuneSubscribeOptionInit,
} from "./TuneSubscribeOption";
import type { TuneSubscribeOption } from "./TuneSubscribeOption";

export const normalizeTuneSubscribeOption = (
  option: Partial<TuneSubscribeOption> = {}
): TuneSubscribeOption => {
  const normalized: TuneSubscribeOption = {
    ...tuneSubscribeOptionInit,
    ...option,
  };

  if (
    normalized[tuneSubscribe.stateRankLatestPost] ||
    normalized[tuneSubscribe.stateRankMeta] ||
    normalized[tuneSubscribe.stateRankMetaFavicon]
  ) {
    normalized[tuneSubscribe.stateRank] = true;
  }

  if (
    normalized[tuneSubscribe.stateRankAllLatestPost] ||
    normalized[tuneSubscribe.stateRankAllMeta] ||
    normalized[tuneSubscribe.stateRankAllMetaFavicon]
  ) {
    normalized[tuneSubscribe.stateRankAll] = true;
  }

  return normalized;
};
